import type { DeleteRefusalBody } from "../../../shared/apiTypes";

/**
 * SCRUM-2352: true when a rejected delete's payload is the SCRUM-2350 refusal,
 * `{ errors: [{ msg }], referrers: [...] }`. The payload is whatever
 * `createAppAsyncThunk` rejected with (the server body), so it is checked, not
 * trusted. Kept apart from ReferrersDialog so the error middleware can ask
 * without importing a component.
 */
export function isDeleteRefusal(body: unknown): body is DeleteRefusalBody {
  return Array.isArray((body as { referrers?: unknown } | null)?.referrers);
}

/** The refusal's message, as the server wrote it in `errors[0].msg`. */
export function refusalMessage(body: DeleteRefusalBody): string {
  return body.errors?.[0]?.msg ?? "";
}
